export enum ObjectType {
  UNKNOWN = 0,
  POINT,
  LINE,
  AREA,
  MODEL3D = 5,
}
